import "../../../FhToastContainer.css";
import { computed, openBlock, createElementBlock, Fragment, renderList, createBlock } from "vue";
import FhToastItem from "./FhToastItem/FhToastItem.mjs";
import { _ as _export_sfc } from "../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _hoisted_1 = { class: "fh-toast-container" };
const _sfc_main = {
  __name: "FhToastContainer",
  props: {
    toasts: {
      type: Array
    },
    hideToast: {
      type: Function
    }
  },
  setup(__props) {
    const props = __props;
    const computedToasts = computed(() => {
      return [...props.toasts].reverse();
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(computedToasts.value, (toast) => {
          return openBlock(), createBlock(FhToastItem, {
            key: toast.id,
            toast,
            onHideToast: __props.hideToast
          }, null, 8, ["toast", "onHideToast"]);
        }), 128))
      ]);
    };
  }
};
const FhToastContainer = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-f41ab69e"]]);
export {
  FhToastContainer as default
};
//# sourceMappingURL=FhToastContainer.mjs.map
